"use client";
import "./homeHowItWorks.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { fadeUp } from "@lib/motion";
import RichText from "@components/text/RichText/RichText";
import TextLink from "@components/buttons/TextLink/TextLink";

const STEPS = ["step1", "step2", "step3", "step4"] as const;

export default function HomeHowItWorks({ onTakeQuiz }: { onTakeQuiz: () => void }) {
  const t = useTranslations("home.how");

  return (
    <div id="how-it-works" className="home-how">
      <motion.div className="home-how-head" {...fadeUp()}>
        <p className="home-section-label">{t("label")}</p>
        <h2 className="home-how-headline">
          <RichText translationKey="home.how.headline" />
        </h2>
      </motion.div>

      <motion.div className="home-how-steps" {...fadeUp(0.1)}>
        {STEPS.map((key) => (
          <div key={key} className="home-how-step">
            <p className="home-how-step-num">{t(`steps.${key}.num`)}</p>
            <p className="home-how-step-title">{t(`steps.${key}.title`)}</p>
            <p className="home-how-step-desc">
              {t(`steps.${key}.desc`)}
              {key === "step1" && (
                <>
                  {" "}
                  <TextLink onClick={onTakeQuiz} variant="orange">
                    {t("surveyLink")}
                  </TextLink>
                </>
              )}
            </p>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
